import styled from "@emotion/styled";
import type { StepType } from "./SvyStepper.interface";
import { css } from "@emotion/react";
import { SvyIcon } from "../SvyIcon";

export const Container = styled.ol`
    --svy-stepper-ellipse-size: 24px;
    --svy-stepper-ellipse-border-radius: 50%;
    --svy-stepper-text-color: ${({ theme }) => theme.colors.secondary[400]};
    --svy-stepper-active-text-color: ${({ theme }) => theme.colors.neutral[900]};
    --svy-stepper-background-color: ${({ theme }) => theme.colors.secondary[400]};
    --svy-stepper-active-background-color: ${({ theme }) => theme.colors.primary[500]};

    margin: ${({ theme }) => theme.spacing[1]} 0px;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    justify-content: center;
`;

export const StepperEllipse = styled.span<{ active: boolean; stepType: StepType; completed: boolean }>`
    width: var(--svy-stepper-ellipse-size);
    height: var(--svy-stepper-ellipse-size);
    border-radius: var(--svy-stepper-ellipse-border-radius);
    background-color: var(--svy-stepper-background-color);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: ${({ theme }) => theme.colors.secondary[50]};
    margin-right: ${({ theme, stepType }) => (stepType === "horizontal" ? theme.spacing[1] : "0px")};
    z-index: 1;
    ${({ theme }) => theme.typography["Body/Regular/Text3"]};
    ${({ active }) =>
        active &&
        css`
            background-color: var(--svy-stepper-active-background-color);
            transition: all 0.2s ease-in-out;
        `}
    ${({ active, stepType, completed }) =>
        stepType === "vertical" &&
        active &&
        !completed &&
        css`
            &:after {
                content: "";
                display: block;
                position: absolute;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
                border-radius: var(--svy-stepper-ellipse-border-radius);
                width: calc(var(--svy-stepper-ellipse-size) - 8px);
                height: calc(var(--svy-stepper-ellipse-size) - 8px);
                background-color: var(--svy-stepper-active-background-color);
                border: 2px solid #fff;
            }
        `}
`;

export const StepperLine = styled.span<{ completed: boolean; stepType: StepType }>`
    height: 1px;
    width: 40px;
    margin: 0 ${({ theme }) => theme.spacing[2]};
    background-color: var(--svy-stepper-background-color);
    ${({ completed, stepType }) =>
        completed &&
        stepType === "vertical" &&
        css`
            background-color: var(--svy-stepper-active-background-color);
        `}
    ${({ stepType }) =>
        stepType === "vertical" &&
        css`
            width: 100%;
            height: 2px;
            margin: 0px;
            position: absolute;
            top: calc(var(--svy-stepper-ellipse-size) / 2);
            left: 50%;
            transform: translateY(-50%);
        `}
`;

export const StepperText = styled.p<{ active: boolean; stepType: StepType }>`
    ${({ theme }) => theme.typography["Body/Regular/Text3"]};
    color: var(--svy-stepper-text-color);
    ${({ active, stepType }) =>
        active &&
        stepType === "horizontal" &&
        css`
            color: var(--svy-stepper-active-text-color);
            transition: all 0.2s ease-in-out;
        `}
    ${({ theme, stepType }) =>
        stepType === "vertical" &&
        css`
            margin: 0px;
            ${theme.typography["Body/Bold/Text3"]}
            color: var(--svy-stepper-active-text-color);
        `}
`;

export const StepperStep = styled.li<{ stepType: StepType }>`
    display: flex;
    flex-direction: row;
    position: relative;
    ${({ stepType }) =>
        stepType === "vertical" &&
        css`
            flex-direction: column;
            width: 80px;
        `}
    align-items: center;
    justify-content: center;
    list-style: none;
`;

export const StepperCheckedIcon = styled(SvyIcon)<{ stepType: StepType }>`
    ${({ theme, stepType }) =>
        stepType === "vertical" &&
        css`
            ${theme.typography.Title5}
        `}
`;
